import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import i18n from "i18next";

import { getIsLoadingSelector } from "../../../selectors/selectors";
import { getshipmentRouteStatuses } from "../../../actions";
import Button from "./../../Common/Button";
import Summary from "./Summary";
import Time from "./../../Common/Time";
import Tracking from "./Tracking";

class Routing extends PureComponent {
  static propTypes = {
    getshipmentRouteStatuses: PropTypes.func.isRequired,
    selectedBillOfLading: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    tracking: PropTypes.array,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    isLoading: false,
    isMobile: false,
    tracking: [],
    userMetadata: {}
  };

  state = {
    isSummaryOpen: false
  };

  componentDidMount() {
    if (this.props.selectedBillOfLading) {
      this.props.getshipmentRouteStatuses(this.props.selectedBillOfLading.id);
    }
  }

  get tracking() {
    return this.props.tracking && this.props.tracking.sort((a, b) => new Date(b.statusDate).getTime() - new Date(a.statusDate).getTime());
  }

  handleSummaryButtonClick = () => {
    this.setState({ isSummaryOpen: !this.state.isSummaryOpen });
  };

  render() {
    return (
      <div className="routing__container">
        <div className="routing__header">
          {this.props.isMobile && <Button className="panel-header__summary-trigger" onClick={this.handleSummaryButtonClick} icon="info" />}
          <p className="routing__title">{i18n.t("routing.routing")}</p>
          <Time />
        </div>
        <Summary
          className={this.state.isSummaryOpen ? "--open" : ""}
          selectedBillOfLading={this.props.selectedBillOfLading}
          isMobile={this.props.isMobile}
          onSummaryButtonClick={this.handleSummaryButtonClick}
        />
        <Tracking tracking={this.tracking} isLoading={this.props.isLoading} isMobile={this.props.isMobile} userMetadata={this.props.userMetadata} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: getIsLoadingSelector(state, [getshipmentRouteStatuses.id]),
    tracking: state.billsOfLading.shipmentRouteStatuses,
    userMetadata: state.app.userMetadata
  };
};

export default connect(
  mapStateToProps,
  { getshipmentRouteStatuses }
)(Routing);



// WEBPACK FOOTER //
// ./src/components/BillOfLading/Routing/Routing.js